import {AsyncInlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {SellerRepositoriesFactory} from '../Repositories/factory.js'

class ClearVehicleDraftLocalStorageSellerUseCase extends UseCase {
  #localStorageRepository

  constructor({localStorageRepository}) {
    super()
    this.#localStorageRepository = localStorageRepository
  }

  static create({config}) {
    return new ClearVehicleDraftLocalStorageSellerUseCase({
      localStorageRepository: SellerRepositoriesFactory.localStorageSellerRepository({config})
    })
  }

  @AsyncInlineError()
  async execute() {
    const [error] = await this.#localStorageRepository.clearVehicleDraft()

    if (error) return Promise.reject(error)

    return Promise.resolve()
  }
}

export const factory = ClearVehicleDraftLocalStorageSellerUseCase.create
